import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import styled from '@emotion/styled';
import moment from 'moment';
import { toast } from 'react-toastify';

import InputWrapper from '../../common/InputWrapper';
import Button from '../../common/Button';

import { fetchGetPackingControl, fetchSendPackingControl } from '../../../actions/packing';

import { parseError } from '../../../helpers';

const Wrapper = styled('div')`
  position: relative;
  display: flex;
  padding: 18px 25px 25px 25px;
  .close-button {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    top: 0;
    right: 0;
    cursor: pointer;
    z-index: 1;
    .fe-x {
      display: block;
      font-size: 16px;
    }
  }
  .title-wrapper {
    display: flex;
    align-items: center;
    .title {
      font-size: 15px;
      font-weight: 500;
      color: #565c5f;
    }
    .badge-pill {
      background-color: #7e57bf;
      color: #fff;
      font-weight: 600;
      margin-left: 5px;
      margin-top: 1px;
    }
  }
  .barcode-wrapper {
    display: flex;
    align-items: center;
    margin-top: 10px;
    input {
      font-size: 14px;
      flex: 1;
      min-width: 290px;
    }
  }
  .block-subtitle {
    margin-top: 5px;
    color: #98a6ad;
    font-size: 11px;
    text-transform: uppercase;
    font-weight: 700;
  }
  .orders-wrapper {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    height: 45px;
    margin-top: 10px;
    overflow: hidden;
    &:before {
      content: '';
      width: 100%;
      height: 100%;
      position: absolute;
      right: 0;
      top: 0;
      background: linear-gradient(90deg, rgba(0, 0, 0, 0) 50%, rgba(252, 253, 253, 1) 88%);
    }
    > div {
      font-size: 14px;
      border-right: 1px solid #ebebeb;
      padding-right: 14px;
      margin-right: 14px;
      .order-title {
        color: #000;
        font-weight: 600;
      }
      .order-date {
        color: #a2a3a5;
      }
    }
  }
`;

const PackingControlBlock = (props) => {
  const { packingControlOrders, handleCloseControlBlock, updateOrders, updateStatuses } = props;

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [orders, setOrders] = useState([]);
  const [barcodeValue, setBarcodeValue] = useState('');

  useEffect(() => {
    (async function () {
      await handleGetPackingControl();
    })();
  }, []);

  const handleGetPackingControl = async (sendToast) => {
    setLoading(true);
    await dispatch(fetchGetPackingControl())
      .then((newOrders) => {
        setOrders(newOrders);
        if (sendToast) {
          toast.success(`Заказ ${newOrders[0].orderId} (ШК: ${barcodeValue}) успешно упакован`);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSendPackingControl = async () => {
    setLoading(true);
    await dispatch(fetchSendPackingControl({ id: barcodeValue }))
      .then(() => {
        setBarcodeValue('');
        handleGetPackingControl(true);
        Promise.all([updateStatuses(), updateOrders()]);
      })
      .catch((err) => {
        toast.error(parseError(err));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!loading) {
      handleSendPackingControl();
    }
  };

  return (
    <div className="row mb-2">
      <div className="col-12">
        <Wrapper className="alert alert-light">
          <div className="close-button" onClick={handleCloseControlBlock}>
            <i className="fe-x" />
          </div>
          <div>
            <div className="title-wrapper">
              <span className="title">Режим контроля упаковки</span>
              <span className="badge badge-pill">{packingControlOrders.length}</span>
            </div>
            <form className="barcode-wrapper" onSubmit={handleSubmit}>
              <InputWrapper
                value={barcodeValue}
                placeholder="Введите штрихкод места / заказа"
                onChange={(e) => setBarcodeValue(e.target.value)}
              />
              <Button
                type="submit"
                className="ml-2"
                text="Упакован"
                disabled={loading}
                loading={loading}
              />
            </form>
          </div>
          <div style={{ marginLeft: '40px', flex: 1 }}>
            <div className="block-subtitle">Последние упакованные заказы</div>
            <div className="orders-wrapper">
              {orders.map((o) => (
                <div key={o.orderId}>
                  <div className="order-title">{o.orderId}</div>
                  <div className="order-date">
                    {moment(o.packingControlDate).format('DD MMM, HH:mm')}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Wrapper>
      </div>
    </div>
  );
};

export default PackingControlBlock;
